export default "__VITE_ASSET__qXfkiLzm__"